import React from "react";
import styled from "styled-components";
import {useMenu} from "../../data/hooks/menu";
import {InternalLink} from "../../style/itf-styled-components";

const Container = styled.div`
  position: absolute;
  width: 100%;
  background-color: ${props => props.theme.colors.neutrals._000};
  top: 45px;
  left: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const MenuItem = styled(InternalLink)`
  color: ${props => props.theme.colors.neutrals.textDefault};
  border-bottom: 1px solid ${props => props.theme.colors.neutrals._300};
  padding: 25px;
  font-weight: 700;
  text-decoration: underline;
`;

const ActiveMenuItem = styled(MenuItem)`
  background-color: ${props => props.theme.colors.neutrals._100};
  text-decoration: none;
`;

const MobileMenu = ({page}) => {
  const menu = useMenu();

  return (
    <Container>
      {menu.map((item, index) => (
        item.page === page
          ? (<ActiveMenuItem
              to={item.link}
              key={index}
            >{item.label}</ActiveMenuItem>)
          : (<MenuItem
              to={item.link}
              key={index}
            >{item.label}</MenuItem>)
      ))}
    </Container>
  );
};

export default MobileMenu;